import { alpha, Box, styled } from "@mui/material";

export const EditorBox = styled(Box)(({ theme }) => ({
  width: '100%',
  '& .ck-editor': {
    border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  '& .ck-editor__main': {
    minHeight: '150px',
    border: 'none',
  },
  '& .ck-content': {
    minHeight: '120px',
    padding: theme.spacing(2),
    border: 'none',
  },
  '& .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content': {
    border: 'none',
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),

  },
  '& .ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable)': {
    border: 'none',
  },
  '& .ck.ck-toolbar>.ck-toolbar__items ': {
    border: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
    display: 'flex',
    flexGrow: 'inherit',
    borderRadius: theme.shape.borderRadius,
  },

  '& .ck-button': {
    color: theme.palette.text.secondary,
  },
  '& .ck-button:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .ck-button.ck-on': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }
}));
